import React from "react";
import { Link } from "react-router-dom";
import { Home, List, MessageCircle } from "lucide-react";
import LoginButton from "./LoginButton";
import AuthContextProvider from "../../lib/contexts/AuthContext";
import "../../css/Header/Navbar.css";
import logo from "../../assets/Precision_logo.png";

export default function Navbar() {
  return (
    <div className="d-flex justify-content-center sticky-top">
      <nav className="navbar navbar-expand-sm navbar-main">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand">
            <img src={logo} alt="Logo" height="55" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mynavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="mynavbar">
            <ul className="navbar-nav m-auto gap-3">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  <Home size={18} /> Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/magazines" className="nav-link">
                  <Home size={18} /> Magazine
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/categorie" className="nav-link">
                  <List size={18} /> Categories
                </Link>
              </li>

              <li className="nav-item">
                <Link to="/" className="nav-link">
                  <MessageCircle size={18} /> Contact Us
                </Link>
              </li>
            </ul>
            <AuthContextProvider>
              <LoginButton />
            </AuthContextProvider>
          </div>
        </div>
      </nav>
    </div>
  );
}
